import alertAtom from 'atom/alertAtom';
import { useAtom } from 'jotai';

const useGlobalAlert = () => {
  const [alert, setAlert] = useAtom(alertAtom);

  const showAlert = (type: string, message: string) => {
    setAlert({ isOpen: true, type, message });
  };

  const hideAlert = () => {
    setAlert({ isOpen: false, type: '', message: '' });
  };

  return {
    showAlert,
    hideAlert,
    isOpen: alert.isOpen
  };
};

export default useGlobalAlert;
